import { styled } from '@mui/material/styles';
import { Typography, TypographyProps } from '@mui/material';

const CustomSmallText = styled(Typography)(({ theme }) => `
  color: ${(theme.palette as any).blue?.main || theme.palette.primary.main};
  text-align: center;
  font-size: .9em;
  margin: 0;
`);

const SmallText: React.FC<TypographyProps> = (props) => <CustomSmallText {...props} />;

export default SmallText;

